import { Control, Controller, UseFormRegister, UseFormSetValue } from 'react-hook-form';

import { HooksFormInput } from '../../../components/Inputs/FormInput/HooksFormInput';
import { HooksFormTextArea } from '../../../components/Inputs/FormTextArea/HooksFormTextArea';
import { useUserInfo } from '../../../helpers/hooks/useUserInfo';
import { FishingWater } from '../types/FishingWater';
import { SuggestedWaterFormState } from '../types/SuggestedWaterForm';

import { FileUploadField } from './Fields/FileUploadField';

interface AdditionalInfoFieldsProps {
  register: UseFormRegister<SuggestedWaterFormState>;
  control: Control<SuggestedWaterFormState>;
  setValue: UseFormSetValue<SuggestedWaterFormState>;
  fishingWater: FishingWater;
  isNewForm?: boolean;
}

export const AdditionalInfoFields = ({
  register,
  control,
  setValue,
  fishingWater,
  isNewForm = false,
}: AdditionalInfoFieldsProps) => {
  const { isLoggedIn } = useUserInfo();

  return (
    <div>
      <HooksFormInput<SuggestedWaterFormState>
        id="url"
        label="Official website"
        className="mb-4 font-semibold"
        register={register}
        inputProps={{
          placeholder: isNewForm ? 'Enter official website URL' : fishingWater.url,
        }}
      />
      <HooksFormTextArea<SuggestedWaterFormState>
        id="additionalInformation"
        inputProps={{ rows: 3 }}
        label="More details"
        className="mb-4 font-semibold"
        register={register}
        placeholder={
          isNewForm
            ? 'Provide extra information about the fishing water'
            : 'Provide extra information about your suggested changes'
        }
      />
      {isLoggedIn && (
        <Controller
          control={control}
          name="attachments"
          defaultValue={[]}
          render={({ field: { name } }) => {
            return <FileUploadField name={name} setValue={setValue} />;
          }}
        />
      )}
    </div>
  );
};
